import { Step } from '../components/steps/Step';
import { NotSure, OnboardingFlows } from './common';

export const targetAudienceBusiness: Step = {
    id: OnboardingFlows.TargetAudience,
    title: 'Who is your target audience?',
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Consumers',
        },
        {
            label: 'Internal teams',
        },
        {
            label: 'Businesses',
        },
        {
            label: 'Family or friends',
        },
        {
            label: NotSure,
        },
    ],
};
